import { render, staticRenderFns } from "./SettingHistory.vue?vue&type=template&id=9cf4a5f8"
import script from "./SettingHistory.vue?vue&type=script&lang=js"
export * from "./SettingHistory.vue?vue&type=script&lang=js"
import style0 from "./SettingHistory.vue?vue&type=style&index=0&id=9cf4a5f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
